import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#231F20] tw-borer tw-border-[0px] tw-border-t tw-border-solid tw-border-[#EEF0F1]" }
const _hoisted_2 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold tw-text-[#211F58] tw-mb-[5px]" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-[10px]" }
const _hoisted_4 = { class: "tw-p-[25px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_6 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_9 = { class: "input-container email-container tw-flex" }
const _hoisted_10 = { class: "input-container tw-grow tw-flex-1" }

import { getComponentUiText } from "@/utils/utilities";
import { reactive, watch, onBeforeUnmount } from "vue";
import { BFormInput } from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import BaseInput from "../common/form/baseInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { helpers, required } from "@vuelidate/validators";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorDetails',
  props: {
  modelValue: {
    type: Object,
    required: true,
  },
},
  emits: ["update:isDisabled", "update:modelValue"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const formModel = reactive({ ...props.modelValue });



const rules = {
  companyName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  description: {},
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
    if (value.companyName) {
      emit("update:isDisabled", true);
    } else {
      emit("update:isDisabled", false);
    }
  },
  { deep: true },
);

onBeforeUnmount(() => {
  formModel.companyName = "";
  formModel.description = "";
});

const isCheckValid = async () => {
  await $v.value.$validate();
  let isValid = !$v.value.$errors || $v.value.$errors.length === 0;

  return { isValid };
};

__expose({
  isCheckValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            "app-vendor-create-new-vendor-assessment-modal-title-vendor-details-1",
          )) + " ", 1),
        _createElementVNode("span", null, [
          _createVNode(ButtonShowDuplicateAssessment, {
            "id-popover": 'popover-vendor-details',
            "custom-class": 'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
            class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
            classes: `!tw-leading-none`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                      "app-vendor-create-new-vendor-assessment-modal-title-vendor-details-1",
                    )), 1),
                  _createVNode(CustomDescriptionContent, {
                    description: 
                    _unref(getComponentUiText)(
                      'app-vendor-create-new-vendor-assessment-modal-popover-description-vendor-details-vendor-1',
                    )
                  ,
                    class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                  }, null, 8, ["description"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(BaseInput, {
        id: "name",
        modelValue: formModel.companyName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.companyName) = $event)),
        validation: _unref($v).companyName,
        container: 'tw-w-full ',
        "data-cy-id": "vendor-details-company",
        "class-name": '!tw-items-center !tw-mt-[0px]',
        "is-required": true,
        label: 
          _unref(getComponentUiText)(
            'app-vendor-create-new-vendor-assessment-modal-label-company-vendor-details-1',
          )
        ,
        placeholder: 
          _unref(getComponentUiText)(
            'app-vendor-create-new-vendor-assessment-modal-placeholder-company-name-vendor-details-1',
          )
        ,
        onBlur: _cache[1] || (_cache[1] = 
          () => {
            _unref($v).companyName.$validate();
          }
        )
      }, null, 8, ["modelValue", "validation", "label", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(BaseInput, {
        id: "name",
        modelValue: formModel.description,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.description) = $event)),
        container: 'tw-w-full ',
        "class-name": '!tw-items-center !tw-mt-[0px]',
        label: 
          _unref(getComponentUiText)(
            'app-vendor-create-new-vendor-assessment-modal-label-description-vendor-details-1',
          )
        ,
        placeholder: 
          _unref(getComponentUiText)(
            'app-vendor-create-new-vendor-assessment-modal-label-placeholder-description-vendor-details-1',
          )
        
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(BFormInput), {
                modelValue: formModel.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.description) = $event)),
                type: "text",
                placeholder: 
                _unref(getComponentUiText)(
                  'app-vendor-create-new-vendor-assessment-modal-label-placeholder-description-vendor-details-1',
                )
              ,
                "data-cy": "vendor-details-description",
                class: _normalizeClass([
                'form-control input-base-form-input',
                _unref($v).description.$error ? 'is-invalid' : '',
              ]),
                state: _unref($v).description.dirty ? _unref($v).description.$error : null
              }, null, 8, ["modelValue", "placeholder", "class", "state"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "label", "placeholder"])
    ])
  ]))
}
}

})